/*
  © 2024 KondaSoft
  https://www.kondasoft.com
*/

function applyClientSideSearchFilter () {
  const params = new URLSearchParams(window.location.search)
  const q = (params.get('q') || '').trim().toLowerCase()
  const container = document.querySelector('.collection-products-archive .container')
  const list = document.querySelector('#grid_products')
  const items = list ? list.querySelectorAll('.product-card-wrapper[role="list-item"]') : []
  if (!container || !list || !items.length) return

  if (q) {
    let matches = 0
    items.forEach((item) => {
      const title = (item.getAttribute('data-title') || '')
      const tags = (item.getAttribute('data-tags') || '')
      const vendor = (item.getAttribute('data-vendor') || '')
      const ok = title.includes(q) || tags.includes(q) || vendor.includes(q)
      item.style.display = ok ? '' : 'none'
      if (ok) matches++
    })

    let msg = container.querySelector('.js-no-results')
    if (matches === 0) {
      if (!msg) {
        msg = document.createElement('div')
        msg.className = 'row js-no-results'
        msg.innerHTML = '<div class="inner tif-pt-50 col-24 d-flex justify-content-center text-center"><div class="row"><div class="col-24"><p class="p-search">You searched for: "<span class="s-searched text-capitalize"></span>"</p><p class="tif-pt-30">No products were found matching your selection.</p></div></div></div>'
        container.insertBefore(msg, container.firstChild.nextSibling)
      }
      msg.querySelector('.s-searched').textContent = q
      const pagination = container.querySelector('.collection-pagination')
      list.style.display = 'none'
      if (pagination) pagination.style.display = 'none'
    } else if (msg) {
      msg.remove()
      list.style.display = ''
      const pagination = container.querySelector('.collection-pagination')
      if (pagination) pagination.style.display = ''
    }
  } else {
    // Reset view when no q
    items.forEach((item) => { item.style.display = '' })
    const msg = container.querySelector('.js-no-results')
    if (msg) msg.remove()
    const pagination = container.querySelector('.collection-pagination')
    if (pagination) pagination.style.display = ''
  }
}

const loadCollection = async () => {
  const collectionProducts = document.querySelector('.collection-products')
  const productList = collectionProducts.querySelector('.product-list')
  const filters = document.querySelector('.collection-filters')

  if (productList) {
    productList.style.opacity = '.2'
  }

  const response = await fetch(window.location.href)
  const data = await response.text()
  const parser = new DOMParser()
  const newDocument = parser.parseFromString(data, 'text/html')

  collectionProducts?.replaceWith(newDocument.querySelector('.collection-products'))
  filters?.replaceWith(newDocument.querySelector('.collection-filters'))

  window.dispatchEvent(new CustomEvent('kt.collection.loaded'))

  const newCollectionProducts = document.querySelector('.collection-products')
  const navbarHeight = document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight || 0
  newCollectionProducts.style.scrollMarginTop = `${navbarHeight}px`
  newCollectionProducts.scrollIntoView()
  applyClientSideSearchFilter()
}

// Apply on first load as well (non-AJAX navigation)
document.addEventListener('DOMContentLoaded', applyClientSideSearchFilter)

class CollectionFilters extends HTMLElement {
  constructor () {
    super()

    this.form = this.querySelector('form')

    this.form.querySelectorAll('input').forEach(input => {
      input.addEventListener('change', () => {
        const params = new URLSearchParams(new FormData(this.form))
        const url = `${window.location.pathname}?${params.toString()}`
        window.history.replaceState({}, '', url)

        loadCollection()
      })
    })

    this.querySelectorAll('.btn-filters-clear-all').forEach(btn => {
      const params = new URLSearchParams(window.location.search)

      for (const key of params.keys()) {
        if (key.includes('filter.')) {
          btn.removeAttribute('hidden')
        }
      }

      btn.addEventListener('click', () => {
        for (const key of [...params.keys()]) {
          if (key.includes('filter.')) {
            params.delete(key)
          }
        }

        const url = `${window.location.pathname}?${params.toString()}`
        window.history.replaceState({}, '', url)
        loadCollection()
      })
    })
  }
}
customElements.define('collection-filters', CollectionFilters)

class SortBy extends HTMLElement {
  constructor () {
    super()

    this.querySelectorAll('input').forEach(input => {
      input.addEventListener('change', () => {
        this.setUrl(input.value)
        loadCollection()
      })
    })
  }

  setUrl (value) {
    const params = new URLSearchParams(window.location.search)
    params.set('sort_by', value)
    params.delete('page')
    const url = `${window.location.pathname}?${params.toString()}`
    window.history.replaceState({}, '', url)
  }
}
customElements.define('sort-by', SortBy)

class Pagination extends HTMLElement {
  constructor () {
    super()

    this.querySelectorAll('a').forEach(elem => {
      elem.addEventListener('click', (event) => {
        event.preventDefault()

        this.setUrl(elem.dataset.newPage)
        loadCollection()
      })
    })
  }

  setUrl (value) {
    const params = new URLSearchParams(window.location.search)
    params.set('page', value)
    const url = `${window.location.pathname}?${params.toString()}`
    window.history.replaceState({}, '', url)
  }
}
customElements.define('collection-pagination', Pagination)
